<template>
  <div id="how-to-play">
    <div class="play">
      <div class="play-top">
        <v-img :src="require('../assets/img/playtop_sp@2x.png')" width="90%" />
      </div>
      <div class="play-room">
        <v-img :src="require('../assets/img/p1_sp@2x.png')" width="40%" />
        <v-img class="play-room-sentence" :src="require('../assets/img/play1_sp@2x.png')" />
        <v-img class="play-room-character" :src="require('../assets/img/30002_@2x.png')" width="90%" />
      </div>

      <div class="play-shop">
        <v-img :src="require('../assets/img/p2_sp@2x.png')" width="40%" />
        <v-img class="play-shop-sentence" :src="require('../assets/img/play2_sp@2x.png')" width="50%" />
        <v-img class="play-shop-character" :src="require('../assets/img/40@2x.png')" width="75%" />
      </div>

      <div class="play-zukan">
        <v-img :src="require('../assets/img/p3_sp@2x.png')" width="40%" />
        <v-img class="play-zukan-sentence" :src="require('../assets/img/play3_sp@2x.png')" width="50%" />
        <v-img class="play-zukan-character" :src="require('../assets/img/17__@2x.png')" width="70%" />
      </div>

      <div class="play-download">
        <v-img class="play-download-title" :src="require('../assets/img/download_sp.png')" />

        <div class="play-download-btnarea">
          <a href="https://play.google.com/store/apps/details?id=net.cosmojapan.okazu" target="_blank">
            <v-img class="play-download-google" :src="require('../assets/img/google.png')"
          /></a>

          <a href="https://apps.apple.com/app/id1525747193" target="_blank">
            <v-img class="play-download-ios" :src="require('../assets/img/apple.png')"
          /></a>
        </div>
        <v-img class="play-download-wink" :src="require('../assets/img/wink.png')" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Howtoplay',
};
</script>

<style lang="scss" scoped>
.play {
  @media screen and (max-width: 960px) {
    & {
      background-color: #fce8a8;
      position: relative;
      width: 100%;
      max-width: 100%;
      height: auto;
      position: relative;
      background-size: cover;
      text-align: center;
      overflow: hidden;
      padding-top: 50px;
    }

    &-top {
      height: 60%;
      margin-left: 7%;
    }
    &-room {
      position: relative;
      margin-left: 10%;
      margin-top: 20%;
      width: 100%;
      &-sentence {
        position: absolute;
        width: 50%;
        right: 20%;
        bottom: 50%;
      }
      &-character {
        position: absolute;
        margin-left: 30%;
        bottom: -50%;
      }
    }
    &-shop {
      position: relative;
      width: 100%;
      margin-left: 45%;
      margin-top: 8%;

      &-sentence {
        position: absolute;
        width: 50%;
        right: 87%;
        bottom: 50%;
      }
      &-character {
        position: absolute;
        margin-left: -70%;
        margin-top: -50%;
      }
    }
    &-zukan {
      position: relative;
      width: 100%;
      margin-left: 10%;
      margin-top: 8%;

      &-sentence {
        position: absolute;
        width: 50%;
        right: 20%;
        bottom: 20%;
      }
      &-character {
        position: absolute;
        left: 50%;
        top: 30%;
      }
    }

    &-download {
      position: relative;
      margin: 1.5em auto;
      width: 87%; /*幅の調節*/
      height: 55vw;
      color: #666666; /*文字色*/
      background-color: white; /*背景色*/
      border-radius: 45px;

      &-title {
        position: absolute;
        width: 60%;
        top: 11%;
        left: 6%;
        padding-left: 2%;
        padding-right: 2%;
      }
      &-btnarea {
        position: absolute;
        width: 46%;
        bottom: 10%;
        left: 10%;
      }

      &-google {
        margin-bottom: 12px;
      }

      &-wink {
        position: absolute;
        width: 60%;
        bottom: 0;
        right: 0;
        margin-right: -8%;
      }
    }
  }

  @media screen and (min-width: 960px) {
    & {
      position: relative;
      margin: 0 auto;
      background-color: #fce8a8;
    }

    &-top {
      position: relative;
      margin: 0% auto 8.5em;
      width: 60%;
      left: 3%;
      top: 100px;
      max-width: 750px;
    }

    &-room,
    &-shop,
    &-zukan {
      position: relative;
      margin: 0% auto 10%;
      padding: 2% 12% 2% 3.5%;
      width: 65%;
      max-width: 675px;
      background: white;
      border-radius: 50px;
      &-sentence,
      &-character {
        display: none;
      }
    }

    &-room:before {
      content: '';
      position: absolute;
      width: 180%;
      height: 180%;
      top: -30%;
      left: -40%;
      background: url(../assets/img/pc_character1@2x.png) no-repeat, url(../assets/img/pc_character4@2x.png) no-repeat;
      background-size: 35%, 38%;
      background-position: left -2.5% bottom 15%, left 102% bottom 125%;
    }

    &-shop:before {
      content: '';
      position: absolute;
      width: 180%;
      height: 180%;
      top: -30%;
      left: -40%;
      background: url(../assets/img/pc_character2@2x.png) no-repeat, url(../assets/img/pc_character5@2x.png) no-repeat;
      background-size: 33%, 37%;
      background-position: left -2% bottom 7%, left 106% bottom 130%;
    }

    &-zukan:before {
      content: '';
      position: absolute;
      width: 180%;
      height: 180%;
      top: -30%;
      left: -40%;
      background: url(../assets/img/pc_character3@2x.png) no-repeat, url(../assets/img/pc_character6@2x.png) no-repeat;
      background-size: 35%, 39%;
      background-position: left -8% bottom 20%, left 104% bottom 133%;
    }

    &-room:after {
      position: absolute;
      content: '';
      top: 25%;
      right: 7%;
      background: url(../assets/img/play1_pc@2x.png) no-repeat;
      background-size: contain;
      width: 50%;
      height: 50%;
    }

    &-shop:after {
      position: absolute;
      content: '';
      top: 30%;
      right: 7%;
      background: url(../assets/img/play2_pc@2x.png) no-repeat;
      background-size: contain;
      width: 50%;
      height: 50%;
    }

    &-zukan:after {
      position: absolute;
      content: '';
      top: 20%;
      right: 2%;
      background: url(../assets/img/play3_pc@2x.png) no-repeat;
      background-size: contain;
      width: 55%;
      height: 55%;
    }

    &-download {
      position: relative;
      display: inline-block;
      margin: -5em 10% 4.5em;
      background: url(../assets/img/fukidashi_pc@2x.png) no-repeat, url(../assets/img/wink.png) no-repeat;
      background-size: 85%, 43%;
      background-position: top 50% left -30%, top 50% right -18%;
      width: 80%;
      max-width: 1200px;

      &-title {
        position: absolute;
        width: 55%;
        margin: 15% auto auto 7%;
        max-width: 650px;
      }

      &-google,
      &-ios {
        margin-bottom: 12px;
        float: left;
        width: 25%;
        margin: 22% -8% 15% 10%;
        max-width: 280px;
      }

      &-wink {
        display: none;
      }
    }
  }
}
</style>
